<template>
	<b-list-group flush>

		<li class="list-group-item list-group-column p-0 d-flex flex-row border">
			<div class="d-table-cell p-2 mr-auto">
				<p class="mb-0">
					<strong>FORT</strong> <small class="text-muted">Fortitude</small>
				</p>
			</div>
			<div class="d-table-cell p-2 number">{{fortitudeSave}}</div>
			<div class="d-table-cell p-2 rollers">
				<dice-button :data-dice-notation="fortitudeSave | d20roll"></dice-button>
			</div>
		</li>

		<li class="list-group-item list-group-column p-0 d-flex flex-row border">
			<div class="d-table-cell p-2 mr-auto">
				<p class="mb-0">
					<strong>REF</strong> <small class="text-muted">Reflex</small>
				</p>
			</div>
			<div class="d-table-cell p-2 number">{{reflexSave}}</div>
			<div class="d-table-cell p-2 rollers">
				<dice-button :data-dice-notation="reflexSave | d20roll"></dice-button>
			</div>
		</li>
	
		<li class="list-group-item list-group-column p-0 d-flex flex-row border">
			<div class="d-table-cell p-2 mr-auto">
				<p class="mb-0">
					<strong>WILL</strong> <small class="text-muted">Will</small>
				</p>
			</div>
			<div class="d-table-cell p-2 number">{{willSave}}</div>
			<div class="d-table-cell p-2 rollers">
				<dice-button :data-dice-notation="willSave | d20roll"></dice-button>
			</div>
		</li>

		<li class="list-group-item list-group-column p-0 d-flex flex-row border">
			<div class="d-table-cell p-2 mr-auto">
				<p class="mb-0">
					<strong>INIT</strong> <small class="text-muted">Initiative</small>
				</p>
			</div>
			<div class="d-table-cell p-2 number">{{initiative}}</div>
			<div class="d-table-cell p-2 rollers">
				<dice-button :data-dice-notation="initiative | d20roll"></dice-button>
			</div>
		</li>
	</b-list-group>	
</template>

<script>
import DiceButton from '@/components/DiceButton.vue'

export default {
	components: {
		'DiceButton': DiceButton,
	},
	computed: {
		fortitudeSave: function() {
			return this.$store.getters['character/abilityScores/abilityMods'].Constitution + 
			this.$store.state.Character.Levels[ 
				this.$store.getters.currentLevel 
			].Fort
		},
		reflexSave: function() {
			return this.$store.getters['character/abilityScores/abilityMods'].Dexterity + 
			this.$store.state.Character.Levels[ 
				this.$store.getters.currentLevel 
			].Ref
		},
		willSave: function() {
			return this.$store.getters['character/abilityScores/abilityMods'].Wisdom + 
			this.$store.state.Character.Levels[ 
				this.$store.getters.currentLevel 
			].Will
		},
		initiative: function() {
			return this.$store.getters['character/abilityScores/abilityMods'].Dexterity + 
			this.$store.state.Character.Misc.Initiative
		},
	},
}
</script>

<style scoped>
.list-group-column {
    border-right: 1px solid rgba(0,0,0,.125) !important;
    border-left: 1px solid rgba(0,0,0,.125) !important;
}
</style>